import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";

export default {
    mixins: [alertMixins],
    data() {
        return {
            maxPrice: 1000000000,
            maxPriceErrorMsg: ''
        }
    },
    methods: {
        //this.errorAlert(this.$t('withdraw_exp'))
        returnNumber(price) {
            if (!util.isEmpty(price)) {
                return util.Number.returnNumber(price);
            } else {
                return 0;
            }
        },
        returnCommas(price) {
            if (!util.isEmpty(price)) {
                return util.Number.numFormat(price);
            } else {
                return 0;
            }
        },
        returnMaxPrice(price) {
            if (!util.isEmpty(price)) {
                if (util.Number.returnNumber(price) > this.maxPrice) {
                    price = this.maxPrice;
                    // this.maxPriceErrorMsg = this.$t('maxPriceErrorMsg', {price: util.Number.numFormat(this.maxPrice)});
                } else {
                    // this.maxPriceErrorMsg = '';
                }
                return util.Number.returnNumber(price);
            } else {
                return 0;
            }
        },

        setFees(data, price) {
            if (data.i_status === 'auction' || data.i_status === 'pricetag') {
                if (data.ibp_is_change === 0) {
                    if (data.im_status === 2 || data.im_status === 5) {
                        return price * 0.1
                    } else {
                        return 0
                    }
                } else {
                    if (data.i_type === 'digital') {
                        return 0;
                    } else {
                        if (data.im_status === 2 || data.im_status === 5) {
                            return price * 0.1;
                        } else {
                            return 0
                        }
                    }
                }
            } else {
                return 0;
            }
        }

    }
}
